<template>
  <blockquote class="bs3-padding-right-reset contextual-actions-container position-relative">
    <div class="bs3-margin-top5" style="position: absolute; top: 0; right: 5px;">
      <div class="contextual-actions dropdown">
        <a :href="pUrls['updateHistoryEvent'] + '?dataId=' + pHistoryEvent.id + urlParams" class="btn btn-sm btn-default ajax-support show-waiting"
           data-ajax-support-csv="#ajaxModuleForm"><i class="fa-light fa-pencil"></i></a>
        <a :href="pUrls['confirmDeleteHistoryEvent'] + '?dataId=' + pHistoryEvent.id + urlParams" :class="['btn btn-sm btn-default ajax-support show-waiting', {'disabled':pHistoryEvent.system}]"
           data-ajax-support-csv="#ajaxModuleForm"><i class="fa-light fa-remove"></i></a>
      </div>
    </div>
    <p v-if="pHistoryEvent.edited" class="audit help-block history-event-edited"><span ref="historyEditedAudit" class="label label-default" data-toggle="tooltip" :title="pHistoryEvent.editedByName + ' - ' + pHistoryEvent.editedOnDateText">{{pDictionary['dictionary.history.updated']}}</span></p>
    <p class="audit help-block history-event-audit"><strong>{{pHistoryEvent.name}}</strong> - <span class="bs3-margin-right10">{{pHistoryEvent.dateLongText}}</span></p>
    <p v-html="pHistoryEvent.message" class="history-event-message"></p>
    <footer v-if="pHistoryEvent.explanation" class="history-event-explanation">{{pHistoryEvent.explanation}}</footer>
  </blockquote>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";

export default {
  name: "HistoryEvent",
   mixins: [BaseMixin],
  props: {
    pHistoryEvent: Object
  },
   computed: {
      urlParams: function () {
         let urlParams = "";
         if(this.pSrc)
         {
            urlParams += "&src=" + this.pSrc;
         }
         if(this.pSrcId)
         {
            urlParams += "&srcId=" + this.pSrcId;
         }
         return urlParams;
      }
   },
  mounted: function() {
    $(this.$refs.historyEditedAudit).tooltip({container: 'body', sanitize: false});
  },
  unmounted: function() {
    $(this.$refs.historyEditedAudit).tooltip('destroy')
  }
}
</script>

<style scoped>

</style>